import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentTestStartedLogEvent = unifiedAgentEvent<{
  build_session_id: string | null
  is_draft: boolean
  agent_id: number | null
}>('Unified_Agent_Test_Started')
